import { createModulesAPI, deleteModulesAPI, getModuleTreeAPI, moduleGetByIdAPI, modulesMenuMappingAPI, modulesPagingAPI, updateModulesAPI } from "../../../api/url";
import { ResponseArray, ResponseObject } from "../../../common/common.entity";
import { formatTreeViewData } from "../../../common/commonFunctions";
import { createAPI, deleteAPI, getByBodyAPI, getByIdAPI, setReducerState, updateAPI } from "../../../redux/crudSlice";
import { AppDispatch, store } from '../../../store/store';
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { APICallFunction } from "../role/apiCall";
import { ModulesKeys } from "./entity";
const { dispatch } = store

export const getModulesPagingData = async (dispatch: AppDispatch, _request: Object) => {

  const res = await dispatch(
    getByBodyAPI({
      key: ModulesKeys.paging,
      url: modulesPagingAPI,
      request: { ..._request, ['ApplicationId']: getLocalStorageItem('ApplicationId') },
    })
  );

  return res?.payload?.value;
};

export const deleteModule = async (dispatch: AppDispatch, _request: Object) => {
  const res = await dispatch(
    deleteAPI({
      key: ModulesKeys.paging,
      url: deleteModulesAPI,
      request: { ModuleId: _request }
    })
  );

  return res?.payload?.value;
};

export const getModulebyId: APICallFunction = async (params) => {
  const { key = ModulesKeys.get, request = {}, url = moduleGetByIdAPI(request?.id) } = params;
  const res = await dispatch(getByIdAPI({ key: key, url: url }));
  return res?.payload?.value;
}

export const createModule: APICallFunction = async (params) => {
  const { key = ModulesKeys.create, request = {}, url = createModulesAPI } = params;
  request['ApplicationId'] = getLocalStorageItem('ApplicationId');
  const res = await dispatch(createAPI({ key: key, url: url, request: request }));
  return res?.payload?.value;
}
export const updateModule: APICallFunction = async (params) => {
  const { key = ModulesKeys.update, request = {}, url = updateModulesAPI(request.id) } = params;
  const res = await dispatch(updateAPI({ key: key, url: url, request: request }));
  return res?.payload?.value;
}

export const getMenuMapping = async (dispatch: AppDispatch, _request: Object) => {
  await dispatch(getByBodyAPI({
    key: ModulesKeys.getMenus,
    url: modulesMenuMappingAPI,
    request: { ..._request },
  }))
}

// export const deleteMenuMapping = async ( dispatch: AppDispatch, _request: Object) => {
//   await dispatch(deleteAPI({
//       key: ModulesKeys.deleteMenus,
//       url: deleteMenuAPI,
//       request: {MenuId:_request}
//   }))
// }

export const getModulesTree: APICallFunction = async (params) => {
  const { key = ModulesKeys.tree, request = {}, url = getModuleTreeAPI } = params;
  request.ModuleId = request.id
  let res = await dispatch(getByBodyAPI({ key: '', url: url, request: request }));
  res = { data: formatTreeViewData(res?.payload?.data, 'ChildName', 'DisplayName') };

  dispatch(setReducerState({ key: key, value: res }));
  return res;
}



